import { HAS_WINDOW } from '@eventbrite/feature-detection';

const hasSessionStorage = () => HAS_WINDOW && window.sessionStorage;

export const setStorageItem = (key: string, value: any) => {
    if (hasSessionStorage()) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
};

export const getStorageItem = (key: string) => {
    if (!hasSessionStorage()) {
        return;
    }

    let data = sessionStorage.getItem(key);
    if (data) {
        try {
            data = JSON.parse(data);
        } catch (err) {
            data = null;
        }
    }

    return data;
};

export const getLocalStorageItemWithExpiry = (key: string) => {
    try {
        const itemJSON = localStorage.getItem(key);

        if (!itemJSON) return null;

        const { expiry, value } = JSON.parse(itemJSON);
        const now = new Date();

        // * Compare the expiry time of the item with the current time
        if (now.getTime() > expiry) {
            // * If the item is expired, delete the item from storage
            localStorage.removeItem(key);

            return null;
        }

        return value;
    } catch (err) {
        return null;
    }
};
